module.exports = __webpack_public_path__ + "static/media/login_logo_kajave.b4877653.svg";